import moment from "jalali-moment";
import { Fragment } from "react";
import { Form } from "react-bootstrap";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DatePicker from "react-multi-date-picker";

function DateFilter({ value, set, label = "" }) {
  const setTime = e => {
    if (e === null) {
      return set(undefined);
    }

    set(
      moment(e.year + "/" + e.month.number + "/" + e.day, "jYYYY/jM/jD").format(
        "YYYY-MM-DD"
      )
    );
  };

  const getTime = time => {
    return time
      ? moment(time, "YYYY-MM-DD").format("jYYYY/jMM/jDD")
      : undefined;
  };

  return (
    <Fragment>
      <Form.Label>{label}</Form.Label>
      <DatePicker
        calendar={persian}
        locale={persian_fa}
        value={getTime(value)}
        style={{ width: "100%", height: "2.2rem" }}
        onChange={setTime}
      />
    </Fragment>
  );
}

export default DateFilter;
